import { render, staticRenderFns } from "./movedraw.vue?vue&type=template&id=1389104d&scoped=true&"
import script from "./movedraw.vue?vue&type=script&lang=js&"
export * from "./movedraw.vue?vue&type=script&lang=js&"
import style0 from "./movedraw.vue?vue&type=style&index=0&id=1389104d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389104d",
  null
  
)

export default component.exports